import React from 'react';
import {
  Box,
  Container,
  Typography,
  Switch,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import AppMenu from '../../components/AppMenu';
import ComingSoonTag from '../../components/ComingSoonTag';

const Settings: React.FC = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleSignupClick = () => {
    navigate('/signup');
  };

  return (
    <Box>
      <AppMenu 
        currentPath="/settings"
        onLoginClick={handleLoginClick}
        onSignupClick={handleSignupClick}
      />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography 
          variant="h4" 
          component="h1"
          sx={{ 
            fontWeight: 700,
            color: 'primary.main',
            mb: 3,
            fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem' }
          }}
        >
          Settings
        </Typography>
        
        <Box 
          sx={{ 
            width: '100%',
            maxWidth: 600,
            backgroundColor: 'white',
            borderRadius: 2,
            boxShadow: 2,
            overflow: 'hidden'
          }}
        >
          <List sx={{ p: 0 }}>
            <ListItem
              sx={{
                py: 3,
                px: 3,
                borderBottom: '1px solid',
                borderColor: 'divider',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.02)',
                }
              }}
            >
              <ListItemText 
                primary={
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                    Terms and Conditions
                  </Typography>
                }
                secondary={
                  <Typography variant="body2" color="text.secondary">
                    I accept the terms and conditions
                  </Typography>
                }
              />
              <ListItemSecondaryAction sx={{ right: 24, display: 'flex', alignItems: 'center', gap: 1 }}>
                <LockIcon sx={{ fontSize: 18, color: '#4caf50' }} />
                <Switch
                  edge="end"
                  checked={true}
                  disabled
                  sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: '#4caf50',
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      backgroundColor: '#4caf50',
                    },
                    '& .MuiSwitch-switchBase.Mui-disabled': {
                      color: '#4caf50 !important',
                    },
                    '& .MuiSwitch-track': {
                      backgroundColor: '#4caf50 !important',
                      opacity: '0.5 !important',
                    },
                  }}
                />
              </ListItemSecondaryAction>
            </ListItem>

            <ListItem
              sx={{
                py: 3,
                px: 3,
                opacity: 0.6,
                cursor: 'not-allowed',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.02)',
                }
              }}
            >
              <ListItemText 
                primary={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 0 }}>
                      Newsletter Subscription
                    </Typography>
                    <ComingSoonTag />
                  </Box>
                }
                secondary={
                  <Typography variant="body2" color="text.secondary">
                    Subscribe to receive our latest news and updates
                  </Typography>
                }
              />
              <ListItemSecondaryAction sx={{ right: 24 }}>
                <Switch
                  edge="end"
                  checked={false}
                  disabled
                  sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: '#4caf50',
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      backgroundColor: '#4caf50',
                    },
                  }}
                />
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </Box>
      </Container>
    </Box>
  );
};

export default Settings;
